module.exports = __webpack_public_path__ + "img/homepage_wheel.79a567de.png";